import type { GameSettings } from "../model/GameSettings.js";
import type { Engine } from "./Engine.js";
import type { PlayerStateProvider } from "./PlayerStateProvider.js";
import type { PieceProvider } from "./PieceProvider.js";


/**
 * Creates rule sets to match game settings.
 */
export abstract class EngineProvider {

    /**
     * Creates the provider of pieces for the given
     * settings and game metadata.
     */
    abstract createPieceProvider(settings: GameSettings): PieceProvider;

    /**
     * Creates the provider of player states for the given
     * settings and game metadata.
     */
    abstract createPlayerStateProvider(settings: GameSettings): PlayerStateProvider;

    /**
     * Creates a rule set to match the given settings and game metadata.
     */
    abstract create(settings: GameSettings): Engine;
}
